/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1CourseCourseidLanguages201,
  PostApiV1CourseCourseidLanguages400,
  PostApiV1CourseCourseidLanguages401,
  PostApiV1CourseCourseidLanguages404,
  PostApiV1CourseCourseidLanguages500,
  PostApiV1CourseCourseidLanguagesMutationRequest,
  PostApiV1CourseCourseidLanguagesMutationResponse,
  PostApiV1CourseCourseidLanguagesPathParams,
} from "../../types/courseLangsController/PostApiV1CourseCourseidLanguages.ts";
import { courseLangDetailViewModelSchema } from "../courseLangDetailViewModelSchema.ts";
import { courseLangEditorViewModelSchema } from "../courseLangEditorViewModelSchema.ts";

export const postApiV1CourseCourseidLanguagesPathParamsSchema = z.object({
  courseId: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1CourseCourseidLanguagesPathParams>;

/**
 * @description (Created) Objeto criado com sucesso.
 */
export const postApiV1CourseCourseidLanguages201Schema = z.lazy(
  () => courseLangDetailViewModelSchema,
) as unknown as ToZod<PostApiV1CourseCourseidLanguages201>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1CourseCourseidLanguages400Schema =
  z.any() as unknown as ToZod<PostApiV1CourseCourseidLanguages400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1CourseCourseidLanguages401Schema =
  z.any() as unknown as ToZod<PostApiV1CourseCourseidLanguages401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1CourseCourseidLanguages404Schema =
  z.any() as unknown as ToZod<PostApiV1CourseCourseidLanguages404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1CourseCourseidLanguages500Schema =
  z.any() as unknown as ToZod<PostApiV1CourseCourseidLanguages500>;

export const postApiV1CourseCourseidLanguagesMutationRequestSchema = z.lazy(
  () => courseLangEditorViewModelSchema,
) as unknown as ToZod<PostApiV1CourseCourseidLanguagesMutationRequest>;

export const postApiV1CourseCourseidLanguagesMutationResponseSchema = z.lazy(
  () => postApiV1CourseCourseidLanguages201Schema,
) as unknown as ToZod<PostApiV1CourseCourseidLanguagesMutationResponse>;
